<template>
  <b-modal
    :visible="visible"
    title="Register a recruit"
    :hide-footer="true"
    @hide="hide()"
    @shown="onShown()"
  >
    <form
      @submit.prevent="register()"
    >
      <p class="mb-4">
        Enter your recruit's contact information below.
      </p>
      <div class="form-group">
        <div class="mb-2">
          Name
        </div>
        <div class="form-row">
          <div class="col">
            <input
              id="recruit[first_name]"
              v-model="recruit.first_name"
              type="text"
              name="first_name"
              class="form-control"
            >
            <label for="recruit[first_name]"><small>First Name</small></label>
          </div>
          <div class="col">
            <input
              id="recruit[last_name]"
              v-model="recruit.last_name"
              type="text"
              name="last_name"
              class="form-control"
            >
            <label for="recruit[last_name]"><small>Last Name</small></label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="recruit[email]">Email</label>
        <input
          id="recruit[email]"
          v-model="recruit.email"
          type="text"
          name="email"
          class="form-control"
        >
      </div>
      <div class="form-group">
        <label for="recruit[password]">Password</label>
        <input
          id="recruit[password]"
          v-model="recruit.password"
          type="text"
          name="password"
          class="form-control"
        >
      </div>
      <div class="form-group">
        <label for="recruit[office_id]">Office</label>
        <select
          id="recruit[office_id]"
          v-model="recruit.office_id"
          name="office_id"
          class="custom-select"
        >
          <option value="">Choose an office...</option>
          <option v-for="office in offices" v-bind:key="office.id" :value="office.id">
            {{ office.display_name }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label for="recruit[agent_mls_id]">Agent MLS ID</label>
        <input
          id="recruit[agent_mls_id]"
          v-model="recruit.agent_mls_id"
          type="text"
          name="agent_mls_id"
          class="form-control"
        >
      </div>
      <div class="form-group">
        <label for="recruit[split]">Proposed Agent-Side Split</label>
        <input
          id="recruit[split]"
          v-model="recruit.split"
          type="text"
          name="trial_split"
          class="form-control"
        >
        <div class="small help-text">
          The agent-side split; enter <code>70</code> for 70%
        </div>
      </div>
      <div class="form-group">
        <label for="recruit[cap]">Proposed Cap</label>
        <input
          id="recruit[cap]"
          v-model="recruit.cap"
          type="text"
          name="cap"
          class="form-control"
        >
        <div class="small help-text">
          The agent's cap; enter <code>24000</code> for $24,000
        </div>
      </div>
      <hr>
      <button
        class="btn btn-primary btn-block"
        type="submit"
        :disabled="registering"
      >
        <i v-if="registering" class="fa fa-spin fa-circle-o-notch mr-1"></i>
        <span v-if="!registering">
          Register &amp; Impersonate
          <i class="fa fa-arrow-right ml-1"></i>
        </span>
        <span v-if="registering">Registering...</span>
      </button>
      <div
        v-if="trialAlreadyExists"
        class="mt-3 alert alert-info text-center mb-0"
      >
        <div class="mb-3">
          A trial user already exists for this email address.
          Would you like to impersonate them now?
        </div>
        <a
          class="btn btn-block btn-info"
          :href="urls.users.impersonate(trialAlreadyExists.user.id)"
        >
          Impersonate
        </a>
      </div>
      <div
        v-if="error"
        class="mt-3 alert alert-danger text-center mb-0"
      >
        {{ error }}
      </div>
    </form>
  </b-modal>
</template>

<script>
import $ from 'jquery'
import { registerRecruit } from '@/api'
import { MessageBag } from '@/lib/MessageBag'
import urls from '@/api/urls'

const defaultRecruit = {
  first_name: null,
  last_name: null,
  office_id: null,
  email: null,
  password: 'RedwoodRocks',
  agent_mls_id: null,
  split: 70,
  cap: 24000
}

export default {
  props: {
    offices: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      registering: false,
      visible: false,
      error: null,
      recruit: Object.assign({}, defaultRecruit),
      trialAlreadyExists: false,
      urls
    }
  },
  mounted () {
    $(window).on('registerRecruit.requested', () => {
      this.show()
    })
  },
  methods: {
    async register () {
      this.registering = true
      this.error = null
      this.trialAlreadyExists = false
      try {
        let response = await registerRecruit(this.recruit)
        if (response.data.already_exists) {
          this.trialAlreadyExists = response.data
        } else {
          this.recruit = Object.assign({}, defaultRecruit)
          document.location = urls.users.impersonate(response.data.user_id)
        }
      } catch (e) {
        let error = MessageBag.fromResponse(e).first()
        if (error === 'trial_already_exists') {
          this.trialAlreadyExists = true
        } else {
          this.error = error
        }
      } finally {
        this.registering = false
      }
    },
    onShown () {
      //
    },
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
      this.error = null
    }
  }
}
</script>